module.exports = __webpack_public_path__ + "static/media/address.52a2bbf6.svg";